import ComboxboxEmailConfig from "./ComboxboxEmailConfig";

export default ComboxboxEmailConfig